(function() {
  const CAM_CAMPAIGN_CODE = "CC-CAM";

  var friendCode = document.getElementById('atom_campaign_code');
  var submitButtons = document.getElementsByClassName('cart__submit');
  var friendCodeError = document.getElementById('atom_campaign_code_error');

  const BASE_URL = friendCode.dataset.baseUrl;

  function changeButtonEnabled(enabled) {
    for(let i=0;i < submitButtons.length;i++) {
      submitButtons[i].disabled = !enabled;
    }
  }

  function setErrorDisplay(msg = undefined) {
    if (msg === undefined || msg === "") {
      friendCodeError.innerHTML = "";
      friendCode.classList.remove("input--error");
      return;
    }

    friendCodeError.innerHTML = msg;
    friendCode.classList.add("input--error");
  }

  function validateCheckDigit(code) {
    if (code.length <= 1) return false;
    
    let digit = code.charCodeAt(code.length-1) - 0x61;

    let sum = 0;
    for (let i=0;i < code.length - 1;i++) {
      sum += code.charCodeAt(i);
    }
    return (sum%10) == digit;
  }

  function inputEvent() {
    changeButtonEnabled(false);
    setErrorDisplay();

    if (friendCode.value.length == 0) {
      changeButtonEnabled(true);
    } else if (friendCode.value === CAM_CAMPAIGN_CODE) {
      // ユーザ全体で同じコードを使うキャンペーン
      changeButtonEnabled(true);
    } else if (!validateCheckDigit(friendCode.value)) {
      setErrorDisplay("正しいコードを入れてください。");
    } else {
      const query_params = new URLSearchParams({
        code: friendCode.value
      });
      fetch(BASE_URL + '/api/friend_invitations/show_from_code?'+query_params, {
        method: 'get',
        headers: {
          'Accept': 'application/json',
        },
        credentials: 'same-origin'
      }).then(function(response) {
        response.json().then((data) => {
          if (data.ok) {
            changeButtonEnabled(true);
          } else if (data.error_code <= 49999) {
            setErrorDisplay("正しいコードを入れてください。");
          } else {
            setErrorDisplay("通信エラーが発生しました。");
            console.log(data);
          }
        }).catch(function(error) {
          setErrorDisplay("通信エラーが発生しました。");
          console.log(error);
        });
      })
      .catch(function(error) {
        setErrorDisplay("通信エラーが発生しました。");
        // eslint-disable-next-line no-console
        console.log(error);
      });
    }
  }

  // 空カートの時
  if(!friendCode) return;

  inputEvent(); // 初期値(ブラウザバックなど）に対する処理
  friendCode.addEventListener('input', inputEvent);
})();
